/* core start */
export const SET_USER = "SET_USER";
export const SET_SESSION_KEY = "SET_SESSION_KEY";
export const SET_SNACK_MESSAGE_QUEUE = "SET_SNACK_MESSAGE_QUEUE";
export const SET_SNACK_MESSAGE_ITEM = "SET_SNACK_MESSAGE_ITEM";
export const SET_LOGIN_STATE = "SET_LOGIN_STATE";
export const SET_AVAILABLE_SCREENS = "SET_AVAILABLE_SCREENS";
export const SET_SHOW_SPLASH = "SET_SHOW_SPLASH";
export const SET_CHECK_SAVE_IDENTITY = "SET_CHECK_SAVE_IDENTITY";
export const SET_PASSWORD_CHANGE_KEY = "SET_PASSWORD_CHANGE_KEY";
export const SET_PASSWORD_CHANGE_KEY_EXPIRATION = "SET_PASSWORD_CHANGE_KEY_EXPIRATION";
export const SET_MANUAL_PASSWORD_CHANGE = "SET_MANUAL_PASSWORD_CHANGE";
export const SET_PUSH_ENDPOINT = "SET_PUSH_ENDPOINT";
export const SET_PUSH_KEY = "SET_PUSH_KEY";
export const SET_PUSH_AUTH = "SET_PUSH_AUTH";
export const SET_UPDATING_USER = "SET_UPDATING_USER";
export const SET_UPDATE_USER_AGAIN = "SET_UPDATE_USER_AGAIN";
export const SET_BUSY_OPEN = "SET_BUSY_OPEN";
export const SET_BUSY_MESSAGE = "SET_BUSY_MESSAGE";
export const SET_API_INFO = "SET_API_INFO";
export const SET_AGENT_USER_SESSION = "SET_AGENT_USER_SESSION";
/* core end */

/* service start */
export const SET_FILTERS = "SET_FILTERS";
export const SET_CHAT_FILTERS = "SET_CHAT_FILTERS";
export const SET_SHOW_FILTER_DIALOG = "SET_SHOW_FILTER_DIALOG";
export const SET_FILTER_LIST_TEXT = "SET_FILTER_LIST_TEXT";
export const SET_CHAT_FILTER_LIST_TEXT = "SET_CHAT_FILTER_LIST_TEXT";
export const SET_FILTER_TYPE = "SET_FILTER_TYPE";
export const SET_FILTER_DAYS = "SET_FILTER_DAYS";
export const SET_FILTER_SEARCH = "SET_FILTER_SEARCH";
export const SET_FILTER_ACCOUNT_ID = "SET_FILTER_ACCOUNT_ID";
export const SET_FILTER_LOCATION_ID = "SET_FILTER_LOCATION_ID";
export const SET_FILTER_ACCOUNTS = "SET_FILTER_ACCOUNTS";
export const SET_FILTER_LOCATIONS = "SET_FILTER_LOCATIONS";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_ACTIVITY_DETAIL_OPEN = "SET_ACTIVITY_DETAIL_OPEN";
export const SET_CONTACT = "SET_CONTACT";
export const SET_CONTACT_OPEN = "SET_CONTACT_OPEN";
export const SET_CONTACT_CHANGED = "SET_CONTACT_CHANGED";
export const SET_ACTIVITY_VIEW_TYPE = "SET_ACTIVITY_VIEW_TYPE";
export const SET_CONTACTS_SEARCH_TEXT = "SET_CONTACTS_SEARCH_TEXT";
export const SET_UPDATING_HOLD_CALLS = "SET_UPDATING_HOLD_CALLS";
export const SET_UPDATING_MESSAGES = "SET_UPDATING_MESSAGES";
export const SET_UPDATE_MESSAGES_AGAIN = "SET_UPDATE_MESSAGES_AGAIN";
export const SET_STATUS_SELECTION_LISTS = "SET_STATUS_SELECTION_LISTS";
export const SET_STATUS = "SET_STATUS";
export const SET_STATUS_OPEN = "SET_STATUS_OPEN";
export const SET_SMS_TASK = "SET_SMS_TASK";
export const SET_SENDING_SMS = "SET_SENDING_SMS";
export const SET_UPDATING_SMS_TASKS = "SET_UPDATING_SMS_TASKS";
export const SET_UPDATE_SMS_TASKS_AGAIN = "SET_UPDATE_SMS_TASKS_AGAIN";
export const SET_BACKGROUND_UPDATE_SMS_TASKS = "SET_BACKGROUND_UPDATE_SMS_TASKS";
export const UPDATE_SMS_TASK_ARCHIVE_STATUS = "UPDATE_SMS_TASK_ARCHIVE_STATUS";
export const SET_TRANSFER_SERVICES = "SET_TRANSFER_SERVICES";
export const SET_MESSAGES = "SET_MESSAGES";
export const SET_CONTACT_LINK = "SET_CONTACT_LINK";
export const SET_CONTACT_LINK_OPEN = "SET_CONTACT_LINK_OPEN";
export const SET_CONTACT_LINK_CONTACTS = "SET_CONTACT_LINK_CONTACTS";
export const SET_ASSIST_OPEN = "SET_ASSIST_OPEN";
export const SET_CONTACT_LINK_MENU_ANCHOR = "SET_CONTACT_LINK_MENU_ANCHOR";
export const SET_ADD_CONTACT_LINK = "SET_ADD_CONTACT_LINK";
export const SET_ASSIST_TASK = "SET_ASSIST_TASK";
export const SET_SEND_TEXT_OPEN = "SET_SEND_TEXT_OPEN";
export const SET_SOURCE_PHONE_NUMBER_ID = "SET_SOURCE_PHONE_NUMBER_ID";
export const SET_TEXT_PHONE_NUMBER = "SET_TEXT_PHONE_NUMBER";
export const SET_SENDING_TEXT = "SET_SENDING_TEXT";
export const SET_TEXT_SEARCH = "SET_TEXT_SEARCH";
export const SET_TEXT_ARCHIVE_FILTER = "SET_TEXT_ARCHIVE_FILTER";
export const SET_VERIFICATION_CODE = "SET_VERIFICATION_CODE";
export const SET_UNREAD_MESSAGE_COUNT = "SET_UNREAD_MESSAGE_COUNT";
export const SET_UNREAD_CHAT_COUNT = "SET_UNREAD_CHAT_COUNT";
export const SET_BLOCK_NUMBERS_ACCOUNT = "SET_BLOCK_NUMBERS_ACCOUNT";
export const SET_LAST_20_MESSAGES = "SET_LAST_20_MESSAGES";
export const SET_MESSAGES_LOADED = "SET_MESSAGES_LOADED";
export const SET_SHOW_LOADING = "SET_SHOW_LOADING";
export const SET_VIP_CALLERS = "SET_VIP_CALLERS";
export const SET_REPORT_FILES = "SET_REPORT_FILES";
export const SET_PHONE_NUMBER_INSIGHTS = "SET_PHONE_NUMBER_INSIGHTS";
export const SET_UNBLOCK_NUMBER_STATE = "SET_UNBLOCK_NUMBER_STATE"
export const SET_CONFIRM_UNBLOCK_NUMBER = "SET_CONFIRM_UNBLOCK_NUMBER"
export const SET_PURE_CHAT_START_TIME = "SET_PURE_CHAT_START_TIME";
export const SET_PURE_CHAT_END_TIME = "SET_PURE_CHAT_END_TIME";
/* service end */

/* account start */
export const SET_ACCOUNT_ID = "SET_ACCOUNT_ID";
export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_ACCOUNT_LOADING = "SET_ACCOUNT_LOADING";
export const SET_CALLERID_REQUEST = "SET_CALLERID_REQUEST";
export const SET_INVOICE = "SET_INVOICE";
export const SET_INVOICE_OPEN = "SET_INVOICE_OPEN";
export const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";
export const SET_STORED_PAYMENT_OPEN = "SET_STORED_PAYMENT_OPEN";
export const SET_SUBMITTING_PAYMENT = "SET_SUBMITTING_PAYMENT";
export const SET_QUERYING_SURCHARGE = "SET_QUERYING_SURCHARGE";
export const SET_SURCHARGE_QUERIED = "SET_SURCHARGE_QUERIED";
export const SET_SHOW_PAYMENT_CONFIRMATION = "SET_SHOW_PAYMENT_CONFIRMATION";
export const SET_OK_TO_SUBMIT_PAYMENT = "SET_OK_TO_SUBMIT_PAYMENT";
export const SET_SURCHARGE_OBJECT = "SET_SURCHARGE_OBJECT";
export const SET_AUTOPAY_ENROLL_OPEN = "SET_AUTOPAY_ENROLL_OPEN";
export const SET_SUBMITTING_AUTOPAY_ENROLL = "SET_SUBMITTING_AUTOPAY_ENROLL";
export const SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
export const SET_ADD_PAYMENT_METHOD_OPEN = "SET_ADD_PAYMENT_METHOD_OPEN";
export const SET_ADDING_PAYMENT_METHOD = "SET_ADDING_PAYMENT_METHOD";
export const SET_UPDATE_PAYMENT_METHOD_OPEN = "SET_UPDATE_PAYMENT_METHOD_OPEN";
export const SET_UPDATE_PAYMENT_METHOD = "SET_UPDATE_PAYMENT_METHOD";
export const SET_SAVING_PAYMENT_METHOD = "SET_SAVING_PAYMENT_METHOD";
export const SET_PLAID_LINK_TOKEN = "SET_PLAID_LINK_TOKEN";
export const SET_PLAID_AUTH_RESPONSE = "SET_PLAID_AUTH_RESPONSE";
export const SET_ADD_BANK_ACCOUNT_OPEN = "SET_ADD_BANK_ACCOUNT_OPEN";
export const SET_ADDING_BANK_ACCOUNT = "SET_ADDING_BANK_ACCOUNT";
/* account end */

/* accout reports */
export const SET_CALL_SUMMARY_STATS = "SET_CALL_SUMMARY_STATS";
export const SET_CALL_VOLUMES_BAR_GRAPH = "SET_CALL_VOLUMES_BAR_GRAPH";
export const SET_CONTACT_INSIGHTS_BAR_GRAPH = "SET_CONTACT_INSIGHTS_BAR_GRAPH";
export const SET_TASK_BY_INVOICE = "SET_TASK_BY_INVOICE";
export const SET_INVOICE_ID = "SET_INVOICE_ID";

/* billing emails */
export const SET_BILLING_EMAILS = "SET_BILLING_EMAILS";

/* webleads */
export const SET_WEB_LEADS = "SET_WEB_LEADS";

/* phone start */
export const SET_CALL_STATE = "SET_PHONE_STATE";
export const SET_PHONE_OUTCALL = "SET_PHONE_OUTCALL";
export const SET_PHONE_MUTED = "SET_PHONE_MUTED";
export const SET_PHONE_OPEN = "SET_PHONE_OPEN";
export const SET_OUTDIAL_NUMBER = "SET_OUTDIAL_NUMBER";
/* phone end */

/* call handling */
export const SET_CALL_HANDLING_DATA = "SET_CALL_HANDLING_DATA";
export const SET_PHONE_NUMBERS = "SET_PHONE_NUMBERS";
export const SET_CALL_FORM = "SET_CALL_FORM";
export const SET_CALL_FORM_LOADING = "SET_CALL_FORM_LOADING";
export const SET_AI_ACTIONS = "SET_AI_ACTIONS";
export const SET_AI_ACTIONS_LOADING = "SET_AI_ACTIONS_LOADING";
export const SET_WARM_TRANSFER_ENABLED = "SET_WARM_TRANSFER_ENABLED";

export const SET_PDF_DATA = "SET_PDF_DATA";